import { useState } from "react";

interface FaqItemProps {
  question: string;
  answer: string;
}

export default function FaqItem({ question, answer }: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
      >
        <span className="flex items-start gap-2 text-sm font-semibold text-foreground-950">
          <i className="ri-question-line mt-0.5 text-base text-primary-500" />
          {question}
        </span>
        <i
          className={`${
            open ? "ri-subtract-line" : "ri-add-line"
          } shrink-0 text-lg text-foreground-500`}
        />
      </button>
      {open && (
        <div className="border-t border-background-200 bg-background-100 px-5 py-4">
          <p className="text-sm leading-relaxed text-foreground-600">{answer}</p>
        </div>
      )}
    </div>
  );
}